import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name 默认配置
 */
const Settings: ProLayoutProps & {
    pwa?: boolean;
    logo?: string;
} = {
    navTheme: 'light',
    // 拂晓蓝（对齐 xjht）
    colorPrimary: '#1890ff',
    layout: 'mix',
    contentWidth: 'Fluid',
    fixedHeader: false,
    fixSiderbar: true,
    colorWeak: false,
    title: '学神管理端',
    pwa: false,
    logo: '/dist/logo-icon.svg',
    iconfontUrl: '',
    token: {},
};

export default Settings;
